// Shopify Storefront API Configuration
export const SHOPIFY_STORE_URL = import.meta.env.VITE_SHOPIFY_STORE_URL || 'artemergeart.myshopify.com';
export const SHOPIFY_STOREFRONT_ACCESS_TOKEN = import.meta.env.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN || '';

// Backend API URL - supports your local/dev/prod structure
const getApiUrl = () => {
  // Use existing API URL logic if available
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // Otherwise use your URL structure
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_PROD_API_URL || 'https://art-emerge-4744deb5e11a.herokuapp.com/api';
  } else if (import.meta.env.DEV && window.location.hostname !== 'localhost') {
    return import.meta.env.VITE_DEV_API_URL || 'https://art-emerge-staging.herokuapp.com/api';
  } else {
    return import.meta.env.VITE_LOCAL_API_URL || 'http://localhost:5051/api';
  }
};

export const API_BASE_URL = getApiUrl();

// Debug configuration in development
if (import.meta.env.DEV) {
  console.log('🔧 Shopify Config:', {
    storeUrl: SHOPIFY_STORE_URL,
    hasStorefrontToken: !!SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    apiBaseUrl: API_BASE_URL,
    environment: import.meta.env.MODE
  });
} 